import React from "react";
import LegalLayout from "../components/LegalLayout";

const Datenschutz: React.FC = () => (
  <LegalLayout title="Datenschutzerklärung">

    <section>
      <h2>1. Allgemeine Hinweise</h2>
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Personenbezogene Daten
        werden vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften (insbesondere
        der DSGVO und des TTDSG) sowie dieser Datenschutzerklärung verarbeitet. Die Nutzung unserer
        Website ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Soweit auf unseren
        Seiten personenbezogene Daten erhoben werden, erfolgt dies stets auf freiwilliger Basis.
      </p>
    </section>

    <section>
      <h2>2. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
        <strong>AVILA Projektmanagement GmbH</strong><br />
        Grunewaldstraße&nbsp;24<br />
        12165&nbsp;Berlin<br />
        Telefon:&nbsp;+49&nbsp;30&nbsp;374&nbsp;363&nbsp;70<br />
        E-Mail:&nbsp;<a href="mailto:info@avila-projektmanagement.de">info@avila-projektmanagement.de</a>
      </p>
    </section>


    <section>
      <h2>3. Datenschutzbeauftragter</h2>
      <p>
        Für Fragen zur Verarbeitung Ihrer personenbezogenen Daten können Sie sich an unseren
        Datenschutzbeauftragten wenden:<br />
        Herrn Jochen Lingemann<br />
        Kleinaustraße&nbsp;10<br />
        14169&nbsp;Berlin<br />
        Tel:&nbsp;030&nbsp;&ndash;&nbsp;81&nbsp;07&nbsp;07&nbsp;&ndash;&nbsp;44<br />
        E-Mail:&nbsp;<a href="mailto:lingemann@petruswerk.de">lingemann@petruswerk.de</a>
      </p>
    </section>


    <section>
      <h2>4. Erhebung von Zugriffsdaten (Server-Logfiles)</h2>
      <p>
            Beim Aufrufen unserer Website werden automatisch Informationen
            erfasst, die Ihr Browser übermittelt (z. B. IP-Adresse, Datum und
            Uhrzeit des Zugriffs, Browsertyp, verwendetes Betriebssystem,
            Referrer-URL). Diese Daten dienen ausschließlich der Sicherstellung
            des technischen Betriebs, der Systemsicherheit und der Optimierung
            unseres Angebots. Eine Zusammenführung dieser Daten mit anderen
            Datenquellen erfolgt nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit.
            f DSGVO (berechtigtes Interesse an sicherem und stabilem Betrieb).
            Empfänger bzw. Kategorien von Empfängern sind Hosting- und
            IT-Dienstleister (Auftragsverarbeiter gem. Art. 28 DSGVO). Die
            Logfiles werden nur solange gespeichert, wie dies für die genannten
            Zwecke erforderlich ist, und anschließend gelöscht oder
            anonymisiert.
          </p>
    </section>

  

    <section>
      <h2>5. Einbindung von Google Maps (2-Klick-Lösung)</h2>
       <p>
            Auf unserer Website ist eine interaktive Karte von Google Maps
            (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
            Irland) eingebunden. Zum Schutz Ihrer Daten erfolgt die Einbindung
            ausschließlich über eine 2-Klick-Lösung. Beim ersten Aufruf der
            Seite wird keine Verbindung zu den Servern von Google hergestellt
            und keine personenbezogenen Daten übermittelt.
          </p>
          <p>
            Erst nach Ihrer ausdrücklichen Zustimmung („Karte aktivieren“) wird
            die Karte geladen. Dabei können personenbezogene Daten (z. B. Ihre
            IP-Adresse) an Google übertragen und dort verarbeitet werden. Es
            kann nicht ausgeschlossen werden, dass Daten auch in Drittländer (z.
            B. USA) übermittelt werden. Rechtsgrundlage ist Ihre Einwilligung
            gemäß Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung
            jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs. 3
            DSGVO), indem Sie die Karte wieder deaktivieren oder die gespeicherte
            Auswahl im sessionStorage löschen.
          </p>
      <p>
        Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der&nbsp;
        <a
          href="https://policies.google.com/privacy?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          Datenschutzerklärung von Google
        </a>.
      </p>
    </section>


    <section>
      <h2>6. Verwendung lokaler Webfonts</h2>
      <p>
        Diese Website verwendet ausschließlich lokal eingebundene Schriftarten (z.&nbsp;B. „Inter“),
        die von unserem eigenen Server geladen werden. Eine Verbindung zu externen Anbietern wie
        Google Fonts wird nicht hergestellt.
      </p>
    </section>

 
<section>
  <h2>7. Cookies / Lokale Speicherung</h2>

  <p>
    Unsere Website setzt keine eigenen Tracking- oder Marketing-Cookies.
    Es werden ausschließlich technisch notwendige lokale Speichermechanismen
    (sessionStorage) eingesetzt.
  </p>

  <p>
    Für die 2-Klick-Lösung von Google Maps speichern wir einen rein technischen
    Status (z.&nbsp;B. „Google Maps aktiviert“) im sessionStorage, damit Ihre
    Auswahl während der laufenden Sitzung berücksichtigt wird. Diese Speicherung
    erfolgt ausschließlich zu diesem Zweck und wird beim Schließen des Tabs oder
    Browsers automatisch gelöscht.
  </p>

  <p>
    Darüber hinaus wird die von Ihnen gewählte Anzeigepräferenz (heller oder
    dunkler Farbmodus) ebenfalls ausschließlich im sessionStorage gespeichert,
    um die Darstellung der Website während der aktuellen Sitzung konsistent
    anzuzeigen. Auch diese Information enthält keine personenbezogenen Daten und
    wird beim Beenden der Sitzung automatisch entfernt.
  </p>

  <p>
    Hinweis: Nach Aktivierung der Karte können durch Google (als Drittanbieter)
    Cookies gesetzt und personenbezogene Daten verarbeitet werden. Details hierzu
    finden Sie in Abschnitt&nbsp;5 sowie in den Informationen von Google.
  </p>
</section>




    <section>
      <h2>8. SSL-/TLS-Verschlüsselung</h2>
      <p>
        Zum Schutz der Übertragung vertraulicher Inhalte nutzt diese Website eine SSL- bzw.
        TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Schloss-Symbol in der
        Adresszeile Ihres Browsers.
      </p>
    </section>


 <section id="rechte" >
         <h2>9. Ihre Rechte als betroffene Person</h2>
          <p>
            Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art.
            16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung
            (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie
            Widerspruch (Art. 21 DSGVO).
          </p>

          <p>
            Sofern eine Verarbeitung auf Ihrer Einwilligung beruht, können Sie
            diese jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs.
            3 DSGVO).
          </p>

          <p>
            <strong>Einzelfallbezogenes Widerspruchsrecht:</strong> Sie haben
            das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
            ergeben, jederzeit gegen die Verarbeitung Sie betreffender
            personenbezogener Daten, die aufgrund von Art. 6 Absatz 1 Buchstabe
            f DS-GVO (Datenverarbeitung auf der Grundlage einer
            Interessenabwägung) erfolgt, Widerspruch einzulegen. In diesem Fall
            werden Ihre personenbezogenen Daten nicht mehr verarbeitet, es sei
            denn, es stehen zwingende schutzwürdige Gründe für die Verarbeitung
            entgegen, die Ihre Interessen, Rechte und Freiheiten überwiegen,
            oder die Verarbeitung dient der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen.
          </p>

          <p>
            Sie haben zudem das Recht, sich bei einer
            Datenschutzaufsichtsbehörde zu beschweren, insbesondere in dem
            Mitgliedstaat Ihres gewöhnlichen Aufenthaltsortes oder des
            mutmaßlichen Verstoßes. Eine Übersicht der Aufsichtsbehörden finden
            Sie unter:{" "}
            <a
              href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html"
              target="_blank"
              rel="noreferrer"
            >
              www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
            </a>
            .
          </p>
        </section>


 
    <section>
      <h2>10. Aktualität und Änderungen</h2>
      <p>
        Diese Datenschutzerklärung ist aktuell gültig (Stand: Juni&nbsp;2026). Durch die
        Weiterentwicklung unserer Website oder gesetzliche Änderungen kann eine Anpassung
        erforderlich werden. Die jeweils aktuelle Fassung finden Sie jederzeit auf dieser Seite.
      </p>
    </section>
  </LegalLayout>
);

export default Datenschutz;
